import React, { useState, useEffect, useContext } from 'react';
import userApi from '../api/UserApi';
import TokenContext from './TokenContext';
import { useSnackbar } from 'notistack';
import { Table, TableBody, TableCell, TableHead, TableRow, Typography, Paper, Button, Modal, TextField, Divider } from '@mui/material';


function Users() {
    const [users, setUsers] = useState([]);
    const [open, setOpen] = useState(false); // Para controlar la apertura del modal
    const [email, setEmail] = useState(''); // Almacena el correo ingresado en el formulario
    const { token } = useContext(TokenContext);
    const { enqueueSnackbar } = useSnackbar();


    useEffect(() => {
        async function fetchUsers() {
            try {
                const userList = await userApi.getUsers(token); // Asume que token está disponible
                setUsers(userList);
            } catch (error) {
                enqueueSnackbar('Error fetching users: ' + error.message, { variant: 'error' });
            }
        }

        fetchUsers();
    }, []);

    const handleOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleSubmit = async () => {
        try {
            await userApi.createUser(email, token);
            enqueueSnackbar('User successfully created!', { variant: 'success' });
            handleClose();
            const updatedUsers = await userApi.getUsers(token);
            setUsers(updatedUsers);
        } catch (error) {
            enqueueSnackbar('Error creating user: ' + error.message, { variant: 'error' });
        }
    };


    return (
        <div style={{ width: '80%', margin: '2rem auto' }}>
            
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
                <Typography variant="h4">
                </Typography>
    
                <Button 
                    variant="contained" 
                    color="primary" 
                    onClick={handleOpen}
                >
                    Create User
                </Button>
            </div>
    
            <Paper elevation={3} style={{ padding: '1rem' }}>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell><Typography variant="subtitle1" style={{ fontWeight: 'bold' }}>ID</Typography></TableCell>
                            <TableCell><Typography variant="subtitle1" style={{ fontWeight: 'bold' }}>Email</Typography></TableCell>
                            <TableCell><Typography variant="subtitle1" style={{ fontWeight: 'bold' }}>Roles</Typography></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {users.map(user => (
                            <TableRow key={user.id}>
                                <TableCell component="th" scope="row">
                                    {user.id}
                                </TableCell>
                                <TableCell>{user.email}</TableCell>
                                <TableCell>{user.roles.map(role => role.name).join(', ')}</TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </Paper>
    
            <Modal 
                open={open} 
                onClose={handleClose}
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}
            >
                <div style={{
                    backgroundColor: 'white',
                    padding: '2rem',
                    width: '30%',
                    outline: 'none',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '1rem'
                }}>
                    <Typography variant="h6">Crear usuario</Typography>
                    <TextField
                        variant="outlined"
                        label="Correo"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                    />
                    <Button 
                        variant="contained" 
                        color="primary" 
                        onClick={handleSubmit}
                    >
                        Enviar
                    </Button>
                </div>
            </Modal>
        </div>
    );
    
    
}

export default Users;
